import { Typography } from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { Institution } from "../../models/Institution";
import styles from "./InstitutionBasicInfo.module.scss";

export interface UploadButtonProps {
  institutionData?: Institution;
}
export default function InstitutionBasicInfo({
  institutionData
}: UploadButtonProps) {

  const { t } = useTranslation();
  return (
    <>
      {institutionData &&
          (
            <Row>
            <Col md={12}>
              <Typography variant="largeBold" component="h2">
                {institutionData.name}
              </Typography>
            </Col>
            <Col md={12} className={styles.oibCol}>
              <Typography variant="medium" component="h3" color="light">
                {`${t("common.oib")}: ${institutionData.oib}`}
              </Typography>
            </Col>
            </Row>
          )
      }
    </>
  );
}
